import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  GridRow,
  GridColumn,
  Button,
  Carousel,
  Img,
} from "arv-reactcomponents";
import { Endpoints } from "npmlinks-constants";

class VerticalCarousel extends Component {
  constructor() {
    super();
    this.state = {
      errorImageIndices: [],
    };
    this.buttonAction = this.buttonAction.bind(this);
    this.renderItems = this.renderItems.bind(this);
    this.onImageError = this.onImageError.bind(this);
  }
  buttonAction(direction) {
    this.props.buttonAction(direction);
  }
  renderItems(item, index, errorImageIndices) {
    const { activeIndex } = this.props;
    return (
      <div
        className={`nw-sasverticalcarousel-imagecontainer ${
          index === activeIndex ? "is-active" : ""
        }`}
        role="presentation"
        onClick={() => this.buttonAction(index)}
      >
        <Img
          className="nw-sasverticalcarousel-image"
          src={(errorImageIndices.includes(index) && Endpoints.noImg) || item}
          onError={() => this.onImageError(index)}
        />
      </div>
    );
  }
  onImageError(index) {
    const { errorImageIndices } = this.state;
    errorImageIndices.push(index);
    this.setState({ errorImageIndices });
  }
  // Endpoints.noImg
  render() {
    const {
      activeIndex,
      data,
      prevButtonDisabled,
      nextButtonDisabled,
      showCarousel,
    } = this.props;
    const { errorImageIndices } = this.state;
    return (
      <GridRow className="nw-sasverticalcarousel-container">
        {showCarousel && (
          <GridColumn>
            <Button
              className="nw-sasverticalcarousel-button"
              onClick={() => this.buttonAction("prev")}
              disabled={prevButtonDisabled}
            >
              <i className="icomoon-arrow_top nw-sasverticalcarousel-buttonicon" />
            </Button>
          </GridColumn>
        )}
        <GridColumn className="nw-sasverticalcarousel-carouselcontainer">
          <Carousel
            className="nw-sasverticalcarousel-carousel"
            index={activeIndex}
            items={data}
            renderItems={(item, index) =>
              this.renderItems(item, index, errorImageIndices)
            }
          />
        </GridColumn>
        {showCarousel && (
          <GridColumn>
            <Button
              className="nw-sasverticalcarousel-button"
              onClick={() => this.buttonAction("next")}
              disabled={nextButtonDisabled}
            >
              <i className="icomoon-arrow_bottom nw-sasverticalcarousel-buttonicon" />
            </Button>
          </GridColumn>
        )}
      </GridRow>
    );
  }
}

VerticalCarousel.propTypes = {
  buttonAction: PropTypes.func.isRequired,
  activeIndex: PropTypes.number.isRequired,
  data: PropTypes.shape({}).isRequired,
  prevButtonDisabled: PropTypes.bool.isRequired,
  nextButtonDisabled: PropTypes.bool.isRequired,
  showCarousel: PropTypes.bool.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: VerticalCarousel,
  component: VerticalCarousel,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/ShopMultiple/VerticalCarousel/index.js